import React, { useState, useEffect, useCallback, useContext } from "react";
import { useParams } from "react-router-dom";
import update from "immutability-helper";
import { useQuery, useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import { 
  REFRESH_TOKEN_MUTATION, 
  STAFF_MODULE_ACCESS_QUERY 
} from "../../graphQL/user_qry";

import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Typography,
  Divider,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import ShortTextIcon from "@mui/icons-material/ShortText";
import SubjectIcon from "@mui/icons-material/Subject";
import TocIcon from "@mui/icons-material/Toc";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { OrderObject } from "./OrderObject.js";
import { FormComponents as Components } from "./FormComponents.js";
import { ComponentDragBox } from "./ComponentDragBox.js";
import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import backImg from "../../assets/icons/back.png";
import dropdownImg from "../../assets/icons/dropdown.png";
import infoImg from "../../assets/icons/info.png";

import { project_url } from "../../constants/Data";

import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY } from "../../graphQL/component_qry";

const UPDATA_COMPONENT_ORDER = `mutation updateComponentOrder($componentId: Int!, $order: Int!) {
  updateComponentOrder(
    componentId: $componentId,
    order: $order,
  ) {
    component {
      componentId
      order
    }
  }
}`;

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: "7rem",
    minWidth: "1400px",
  },
  container: {
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    // height: "936px",
    borderRadius: "8px",
  },
  ComponentDragBox: {
    float: "left",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
    marginBottom: 10,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    //  textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
    marginBottom: 10,
  },
  formNameTextBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  objectBoxStyle: {
    margin: 15,
    borderRadius: "8px",
    border: "1px solid lightGray",
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  formNameTextStyle: {
    fontWeight: 500,
    fontSize: 24,
    // display: "flex",
    paddingTop: 5,
    paddingBottom: 5,
    // alignItems: "center",
    lineHeight: 1,
  },
  backStyle: {
    cursor: "pointer",
    borderRadius: "4px",
    height: 35,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  dragIconBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 12,
    paddingRight: 2,
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
}));

function OrderFormDialog() {
  const { formUuid } = useParams();
  const classes = useStyles();
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const client = useContext(ClientContext);
  const [formName, setFormName] = useState("");
  const [formLink, setFormLink] = useState(null);
  const [lastDroppedComponent, setLastDroppedComponent] = useState(null);
  const [orderObjects, setOrderObjects] = useState([]);
  const [preorderObjects, setPreOrderObjects] = useState([]);
  const [formObjPage, setFormObjPage] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
   
  const [editAccess, setEditAccess] = useState(true);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Forms",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true);}
      else {setEditAccess(false)}


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);


  const [fetchFormComponents] = useManualQuery(GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY, {
    fetchPolicy: "network-only",
  });
  const [updateComponentOrder] = useMutation(UPDATA_COMPONENT_ORDER);

  const convertTxtToRichTxt = txt => {
    //let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
    //Commented by Sami 30Aug2025
    let contentHTML = draftToHtml(JSON.parse(txt));
    contentHTML = contentHTML.replace(/<p>/, "");
    const convertedTxt = ReactHtmlParser(contentHTML);
    return convertedTxt;
  };

  const getFormComponents = async () => {
    if (!formUuid) return;
    const {
      loading: formComponentsLoading,
      error: formComponentsError,
      data: formComponents,
    } = await fetchFormComponents({
      variables: { formUuid: formUuid },
    });
    if (
      !formComponentsLoading &&
      formComponents &&
      formComponents.formComponentAnswerList
    ) {
      // console.log(formComponents.formComponentAnswerList.componentList);
      // console.log("allComponents----", formComponents);
      let a = [];
      setLoadData(true);
      setLastDroppedComponent(null);
      setFormName(formComponents.formComponentAnswerList.name);
      setFormObjPage(`${project_url}/forms/` + formUuid);
      if(!formComponents.formComponentAnswerList.approved)
        setFormLink(`${project_url}/forms/${formUuid}`);

      for (var i in formComponents.formComponentAnswerList.componentList) {
        let frmCmp = formComponents.formComponentAnswerList.componentList[i];
        // console.log(frmCmp);
        let data = {
          id: frmCmp.componentId,
          type: frmCmp.answerTypeId.name,
          order: frmCmp.order,
          infoTxt: frmCmp.tooltip,
          queText: convertTxtToRichTxt(frmCmp.label),
        };
        a.push(data);
      }
      setOrderObjects(a);
      setPreOrderObjects(a);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getFormComponents())();
  }, [formUuid]);

  const handleDrop = useCallback(component => setLastDroppedComponent(component), null);

  const saveOrder = async () => {
    // console.log(orderObjects);
    let a = [];
    for (var i in orderObjects) {
      let order = parseInt(i) + 1;
      // console.log(order);
      // console.log(orderObjects[i].id);
      let {
        loading: loadUpdateComponentOrder,
        error: errorUpdateComponentOrder,
        data: dataUpdateComponentOrder,
      } = await updateComponentOrder({
        variables: {
          componentId: parseInt(orderObjects[i].id),
          order: order,
        },
      });
    }
    navigate(formObjPage);
  };

  const moveOrderObject = useCallback((dragIndex, hoverIndex) => {
    setOrderObjects(prevCards =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      })
    );
  }, []);
  const renderOrderObject = useCallback(
    (object, index) => {
      // console.log(object.type);
      // console.log(index);
      return (
        <OrderObject
          key={object.id}
          index={index} // I think it would be {object.order}
          id={object.id}
          moveObject={moveOrderObject}
        >
          <Box className={classes.objectBoxStyle}>
            <List
              key="01"
              sx={{
                paddingTop: 0,
                paddingBottom: 0,
                "& .MuiListItemButton-root": {
                  cursor: "move",
                },
                "& .MuiListItemButton-root:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <ListItemButton
                disableRipple
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingLeft: 10,
                  paddingTop: 5,
                  paddingBottom: 10,
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    paddingTop: 10,
                  }}
                >
                  {object.type === "text" && (
                    <StyledTooltip title="Object: Text">
                      <ShortTextIcon
                        style={{
                          marginRight: 10,
                          color: "#fff",
                          backgroundColor: "#0057B2",
                          borderRadius: 4,
                        }}
                      />
                    </StyledTooltip>
                  )}
                  {object.type === "textarea" && (
                    <StyledTooltip title="Object: Text Area">
                      <SubjectIcon
                        style={{
                          marginRight: 10,
                          color: "#fff",
                          backgroundColor: "#0057B2",
                          borderRadius: 4,
                        }}
                      />
                    </StyledTooltip>
                  )}
                  {object.type === "content" && (
                    <StyledTooltip title="Object: Content">
                      <TocIcon
                        style={{
                          marginRight: 10,
                          color: "#fff",
                          backgroundColor: "#0057B2",
                          borderRadius: 4,
                        }}
                      />
                    </StyledTooltip>
                  )}
                  {object.type === "drop_down" && (
                    <StyledTooltip title="Object: Drop Down">
                      <img
                        style={{
                          marginRight: 10,
                          borderRadius: 4,
                          height: 24,
                        }}
                        src={dropdownImg}
                      />
                    </StyledTooltip>
                  )}
                  {object.type === "radio_button" && (
                    <StyledTooltip title="Object: Radio Button">
                      <RadioButtonCheckedIcon
                        style={{
                          marginRight: 10,
                          color: "#fff",
                          backgroundColor: "#0057B2",
                          borderRadius: 4,
                        }}
                      />
                    </StyledTooltip>
                  )}

                  {object.type === "checkbox_single" && (
                    <StyledTooltip title="Object: Single Checkbox">
                      <CheckBoxIcon
                        style={{
                          marginRight: 10,
                          color: "#fff",
                          backgroundColor: "#0057B2",
                          borderRadius: 4,
                          // marginTop: 8,
                        }}
                      />
                    </StyledTooltip>
                  )}

                  {object.type === "checkbox_multiple" && (
                    <StyledTooltip title="Object: Multiple Checkboxes">
                      <CheckBoxIcon
                        style={{
                          marginRight: 10,
                          color: "#fff",
                          backgroundColor: "#0057B2",
                          borderRadius: 4,
                          // marginTop: 8,
                        }}
                      />
                    </StyledTooltip>
                  )}
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {object.infoTxt ? (
                      <StyledTooltip title={object.infoTxt}>
                        <img
                          style={{
                            paddingBottom: 3,
                            height: 24,
                            paddingTop: object.type === "Checkbox" && 8,
                          }}
                          src={infoImg}
                        />
                      </StyledTooltip>
                    ) : (
                      ""
                    )}
                  </Box>
                  <Typography variant="h3">
                    <div
                      style={{
                        wordBreak: "break-word",
                        paddingLeft: 5,
                      }}
                    >
                      {object.queText ? object.queText : ""}
                    </div>
                  </Typography>
                </Box>
              </ListItemButton>
            </List>
          </Box>
        </OrderObject>
      );
    },
    [formUuid]
  );
  
   

  if (!loadContent && !loadData) return;
  if (editAccess)
  return (
    <div className={classes.cardContainer}>
      <Header
        breadcrumbs={[
          { label: formName, link: formLink },
          { label: "Reorder", link: null },
        ]}
      />
      <div className={classes.container}>
        <DndProvider backend={HTML5Backend}>
          <Grid container spacing={1}>
            <Grid item style={{ width: 180 }}>
              {/* <Card style={{ height: 450 }}> */}
              <Card>
                <Box mb={1}>
                  <Box
                    mt={2}
                    mb={1}
                    ml={1}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <IconButton>
                      <img
                        src={backImg}
                        height={24}
                        onClick={() => navigate(`${project_url}/forms`)}
                      />
                    </IconButton>
                    <Typography
                      variant="h5"
                      className={classes.backStyle}
                      onClick={() => navigate(`${project_url}/forms`)}
                    >
                      Back
                    </Typography>
                  </Box>
                  <Divider />
                  <Box className={classes.dragIconBoxStyle}>
                    <ComponentDragBox
                      component={Components.TEXT_FIELD}
                      text="Text"
                      icon="ShortTextIcon"
                    />
                  </Box>
                  <Box className={classes.dragIconBoxStyle}>
                    <ComponentDragBox
                      component={Components.TEXT_AREA_FIELD}
                      text="Text Area"
                      icon="SubjectIcon"
                    />
                  </Box>
                  <Box className={classes.dragIconBoxStyle}>
                    <ComponentDragBox
                      component={Components.CONTENT_FIELD}
                      text="Content"
                      icon="TocIcon"
                    />
                  </Box>
                  <Box className={classes.dragIconBoxStyle}>
                    <ComponentDragBox
                      component={Components.DROP_DOWN_FIELD}
                      text="Drop Down"
                      icon="DropDownIcon"
                    />
                  </Box>
                  <Box className={classes.dragIconBoxStyle}>
                    <ComponentDragBox
                      component={Components.RADIO_BUTTON}
                      text="Radio Button"
                      icon="RadioButtonCheckedIcon"
                    />
                  </Box>
                  <Box className={classes.dragIconBoxStyle}>
                    <ComponentDragBox
                      component={Components.CHECKBOX_FIELD}
                      text="Checkbox"
                      icon="CheckBoxIcon"
                    />
                  </Box>
                </Box>
              </Card>
            </Grid>
            <Grid item lg md xl xs style={{ width: 1220 }}>
              {/* <Card style={{ height: 936 }}> */}
              <Card>
                <Box
                  mb={1.5}
                  ml={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ width: "80%", marginTop: 18 }}
                >
                  <Typography variant="h1" className={classes.formNameTextStyle}>
                    {formName}
                  </Typography>
                  <Box sx={{ flex: 1, textAlign: "center" }}>
                    <Typography
                      variant="h1"
                      className={classes.formNameTextStyle}
                      // align="center"
                    >
                      Form Objects Reorder
                    </Typography>
                  </Box>
                </Box>
                <Divider />

                {<>{orderObjects.map((object, i) => renderOrderObject(object, i))}</>}

                {
                  <Box mt={2} ml={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonStyle}
                      style={{ marginRight: 2 }}
                      onClick={() => {
                        saveOrder();
                      }}
                    >
                      Save Reorder
                    </Button>
                    <Button
                      variant="text"
                      color="primary"
                      className={classes.outlinedButtonStyle}
                      onClick={() => navigate(formObjPage)}
                    >
                      Cancel
                    </Button>
                  </Box>
                }
              </Card>
            </Grid>
          </Grid>
        </DndProvider>
      </div>
    </div>
  );

 else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
}

export default OrderFormDialog;
